'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerPartnershipsComponent = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sellerPartnershipsComponent = exports.sellerPartnershipsComponent = {
    template: require('./partnerships.html'),
    bindings: {
        seller: '<',
        partnershipModel: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "$state", "partnershipsService", "gettextCatalog", "exceptionService", "Analytics", function newsOverviewController(common, $state, partnershipsService, gettextCatalog, exceptionService, Analytics) {
        'ngInject';

        var vm = this;
        vm.pagecountList = [12, 24, 36];
        vm.goToPage = goToPage;
        // vm.paging = null;
        vm.isLoading = false;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.searchPartnerships = searchPartnerships;
        vm.searchValue = null;
        vm.clear = clear;
        vm.$onInit = init;
        vm.partnerships = [];

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('partnerships'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/partnerships', vm.seller.name + ' ' + gettextCatalog.getString('partnerships'));
            updateFarmaPartnerShips();
        }

        /* Clear searches */
        function clear() {
            vm.searchValue = null;
            handleGetPartnerships({
                take: 50
            }, 1);
        }

        /* Search partnerships */
        function searchPartnerships() {
            handleGetPartnerships({
                take: 50,
                title: vm.searchValue
            }, 1);
        }

        /* navigate to page */
        function goToPage(page) {
            if (page === 0 || page > vm.partnershipModel.paging.pageCount) {
                return;
            }
            handleGetPartnerships({
                take: 50
            }, page);
        }

        /* Change amount of items per page */
        function changeItemsPerPage(_ref) {
            var itemsPerPage = _ref.itemsPerPage;

            $state.go('.', {
                page: 1
            });
            handleGetPartnerships({
                take: itemsPerPage
            }, 1);
        }

        /* Load partnerships */
        function handleGetPartnerships(searchRequest, page) {
            searchRequest.sellerId = vm.seller.id;

            partnershipsService.getAll(partnershipsService.init(searchRequest.take), searchRequest, page).then(function (result) {
                vm.isLoading = false;
                vm.partnershipModel = result;
                updateFarmaPartnerShips();
            }).catch(function () {
                var msg = gettextCatalog.getString('The partnerships could not be retrieved');
                exceptionService.logException(msg);
            }).finally(function () {
                return vm.isLoading = false;
            });
        }

        function updateFarmaPartnerShips() {
            var test = _lodash2.default.orderBy(vm.partnershipModel.partnerships, ['typePriority', 'priority']);
            vm.partnerships = _lodash2.default.groupBy(test, 'typeName');
        }
    }]

};


//////////////////
// WEBPACK FOOTER
// ./features/seller/partnerships.js
// module id = 1025
// module chunks = 0